let dashForm = function() {
    this.$router.push({
        name: "JobsRdash",
        params: { new: "new", dash: "dash" },
    });
};
export default dashForm;
